<template>
<div>

    <v-card elevation="0" v-if="member" class="profile animate__animated animate__fadeIn">
        <v-card-text>

            <div class="row start">
                <div class="col-2"> <img :src="member.avatar.big" style="width:150px;" />
                <div>  
                    <UploadPicture :label="'เปลี่ยนรูป'" :mode="'button'" :configUploadName="'AVATAR'" :defaultPicture="defaultPicture" @pictureName="setPicture" />
</div>
                </div>
                <div class="col-10">

                     <h3>{{member.firstname}} {{member.lastname}}</h3>
                    <div class="mt-3">
                        <div v-html="member.group.html"></div>
                    </div>

                    <div class="mt-3" v-if="$MEMBER_POINT">คะแนน <span style="color:#F9611E">{{$MEMBER_POINT.total_point}}</span></div>

                </div>
            </div>
            <v-divider class="mt-5 mb-2"></v-divider>

            <div class="row start">
                <div class="col-sm-6">
               

                    <div class="topic">อายุ</div>
                    <div>{{member.age}} ปี</div>

                    <div class="topic">เพศ</div>
                    <div>{{member.gender }}</div>

                    <div class="topic">วันเกิด</div>
                    <div>{{$moment(member.birthdate, 'YYYY-MM-DD h:mm:ss').format('วันddddที่ DD เดือน MMMM ปี YYYY' ) }}</div>

                </div>
                <div class="col-sm-6">

                    <div class="topic">ที่อยู่</div>
                    <div class="mt-2">{{member.address}}
                        จังหวัด{{member.province }}
                        {{member.zipcode}}</div>

                    <div v-if="member.group_id==1">
                        <div class="topic">ร้าน</div>
                        <div class="mt-2">{{member.company}}</div>
                    </div>

                    <div v-if="member.group_id==2">
                        <div class="topic">สถานศึกษา</div>
                        <div class="mt-2">{{member.academy}}</div>
                    </div>

                    <div v-if="member.group_id==3">
                        <div class="topic">อาชีพ</div>
                        <div class="mt-2">{{member.job}}</div>

                        <div class="topic">สถานที่ทำงาน</div>
                        <div class="mt-2">{{member.workplace}}</div>
                    </div>

                    <div class="topic">วันที่สมัคร</div>
                    <div class="mt-2">{{$moment(member.register_date, 'YYYY-MM-DD h:mm:ss').format('วันddddที่ DD เดือน MMMM ปี YYYY' ) }}</div>
                </div>
            </div>

        </v-card-text>

    </v-card>

</div>
</template>

<script>
import UploadPicture from '@/inc/Comp/UploadPicture'
export default {

    components: {
        UploadPicture
    },

    data: () => ({
        defaultPicture: null,
        member: null,

        data: {
            member_id: null,
            picture: null,

        },

    }),

    watch: {

    },
    methods: {

        setPicture(val) { 
            this.data.picture = val
            if(val) {
                this.updateMember()
            }
        },

         updateMember() {

            let url = "account/update";
  
            let $vm = this;
           

            const formData = this.$formData(
                this.data
            );

            this.$API
                .post(url, $vm.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res)
                    $vm.memberOne()
                     
                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        memberOne() {
            let $vm = this;
            this.loading = true;

            $vm.$FULL_LOADING = true;

            var url =
                "account/one"
            this.$API
                .post(url, this.formData())
                .then(function (res) {
                    $vm.checkApi(res);
                    $vm.member = res.data.member;
                    $vm.data = res.data.member;
                    $vm.$MEMBER = res.data.member;

                    $vm.defaultPicture = res.data.pic.default;
                    $vm.data.picture = res.data.old_picture

                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    },
    created() {

        this.memberOne()

    },
};
</script>
